function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import { baseURL } from "./consts";
var baseSize = 52;

var getURL = function getURL(name) {
  return function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var url = "".concat(baseURL, "/feature-icons/").concat(baseSize * size, "x").concat(baseSize * size, "/").concat(name, ".png");

    if (size > 1) {
      return "".concat(url, " ").concat(size, "x");
    }

    return url;
  };
};

var generateURL = function generateURL(name) {
  var urlWithName = getURL(name);
  return {
    src: urlWithName(),
    srcSet: [urlWithName(2), urlWithName(3)].join(",")
  };
};

export var StyledFeatureIcon = styled(function (_ref) {
  var className = _ref.className,
      name = _ref.name,
      dataTest = _ref.dataTest;
  return React.createElement("img", _extends({
    className: className,
    alt: name,
    "data-test": dataTest
  }, generateURL(name)));
}).withConfig({
  displayName: "FeatureIcon__StyledFeatureIcon",
  componentId: "sc-1jtew1g-0"
})(["height:", "px;width:auto;background-color:transparent;"], baseSize);
StyledFeatureIcon.defaultProps = {
  theme: defaultTheme
};

var FeatureIcon = function FeatureIcon(_ref2) {
  var name = _ref2.name,
      dataTest = _ref2.dataTest;
  return React.createElement(StyledFeatureIcon, {
    name: name,
    dataTest: dataTest
  });
};

export default FeatureIcon;